import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/la/admin/pay/order/list',
      // url: '/la/admin/workorder/deposite_audit_List',
      data
    });
  },
  setPass({data}) {
    return http.post({
      url: '/la/admin/workorder/deposite_audit',
      data,
      dataType: 'form'
    });
  },
  pass({id}){
    return http.post({
      url:`/la/admin/pay/order/pass?id=${id}`,
  
    })
  },
  noPass({id}){
    return http.post({
      url:`/la/admin/pay/order/no/pass?id=${id}`,
    
    })
  },
  exportExcel({  auditStatus, startTime, endTime }){
    return http.get({
        url: `/la/admin/workorder/deposite_audit_List/excel?auditStatus=${auditStatus}&startTime=${startTime}&endTime=${endTime}`,
        responseType:'blob',
    })
  },
};
